import React from 'react';
import '../../Work-css/About_us.css';
import BG_AU from '../../Work-Assets/LUXURY-HOSTEL_PARIS-1.png';
import STAFF from '../../Work-Assets/Hierachy.png';
import STAFF_2 from '../../Work-Assets/IMG-20241205-WA0085.jpg';
import STAFF_3 from '../../Work-Assets/Wilson.jpeg';
import CEO from '../../Work-Assets/IMG-20241205-WA0080.jpg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function About_us({about}) {

  const x = () =>
  {
    about(false)
  }
  return (
    <div className="whole_AU">
      <div className='close_tab' onClick={x}><FontAwesomeIcon icon={faArrowLeft} /></div>
      <div className='ENT'>ENTITY TRUST</div>
      <div className="whole_AU_IMG">
      
      
      <img src={STAFF} />
    
      </div>


    
    </div>
  );
}

export default About_us;